import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getImagesList } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class generalImages extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              imagesList: [],
              openedAdd:false
        };

        this.getImagesList();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_school', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });

      $(document).on('click', '.stamp_it', function () {

        var item_id = $(this).data("id");

        THIS.openInfo(item_id);
        
      });

    }

    openAddBox= () => {

      this.setState({openedAdd:true});
    }


    getImagesList = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getImagesList(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            imagesList: res.data
            
          });
        } else {
          this.setState({
            imagesList: [],
          });
        }
      });
    }    

    render() {

        const { imagesList } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Images</h4>
                 
 
                  <div class="float-right"><button class="btn btn-inverse-primary" onClick={this.openAddBox}>Add New</button></div>
                 
                  {this.state.openedAdd &&

                     <div class="row col-lg-12">
                      <div class="form-group">
                        
                        <div class="form-row">
                          
                          <label>Image name</label>
                          <input type="text" class="form-control" name="name" />

                        </div>

                        <div class="form-row">
                          
                          <label>Choose image</label>

                          <input type="file" class="form-control" name="image" />

                        </div>

                        <div class="form-row">
                          <button class="btn btn-primary btn-sm">Upload Image</button>
                        </div>

                      </div>

                     </div>
                  }
                  
                  <div class="row col-lg-12">
                    
                    {imagesList.map((item, i) => {     
                      
                       return <div class="bordered">
                            <h4><b>{item.name}</b></h4>
                            <div class="imagebox">
                              <img src={item.imagepath} width="200"/>
                            </div>
                            <div><br/>
                              <button class="btn btn-primary btn-sm">Copy URL</button>
                            </div>
                        </div>

                      })

                      }   
                     
                  </div>
                    
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default generalImages;


// WEBPACK FOOTER //
// ./src/components/bewise/generalImages.jsx